import React, { Fragment as _ } from 'react';

const AssessmentResults = ({ children, ...props }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'yellow',
      }}
    >
      <h1>Assessment Results</h1>
    </div>
  );
};

export default AssessmentResults;
